import React, { ReactNode } from "react";
import { Box, Stack } from "@mui/material";
import theme from "../../theme";

interface MobileDataGridProps<T> {
  rows: T[];
  renderRow: (row: T, index: number) => ReactNode;
  getRowId?: (row: T, index: number) => string | number;
  emptyState?: ReactNode;
}

const MobileDataGrid = <T,>(props: MobileDataGridProps<T>) => {
  const { rows, renderRow, getRowId, emptyState } = props;

  if (!rows || rows.length === 0) return <>{emptyState ?? null}</>;

  return (
    <Stack spacing={2} sx={{ alignItems: "stretch", width: "100%" }} useFlexGap>
      {rows.map((row, index) => (
        <Box
          key={(getRowId && getRowId(row, index)) ?? index}
          width="100%"
          display="flex"
          flexDirection="column"
          sx={{
            backgroundColor: theme.palette.background.default,
            padding: 2,
            borderRadius: 2,
          }}
        >
          {renderRow(row, index)}
        </Box>
      ))}
    </Stack>
  );
};

export default MobileDataGrid;
